<template>
    <div>
        <!--Will Not Toggle Properly if put into a class...Leave inline-->
        <div style="width:100%; height: 65vh;" id='planning'></div>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl';
    import {mapActions, mapGetters} from 'vuex'
    /*import mapHelpers from "../../utils/helpers/mapHelpers";*/
    export default {
        name: 'planning-map-view',
        data: () => ({
            map: null,
            accessToken: 'pk.eyJ1IjoiaG9za2luc3QiLCJhIjoiY2s5M2N6NHprMDEwNDNkbWJieThzbm1hNiJ9.0F7I8B6DKLxTzAXg1oN9Hw',
            mapStyle: 'mapbox://styles/mapbox/outdoors-v12',
            coordinates: [-122.9110, 49.2057],
            currentMarkers: []
        }),
        mounted() {
            this.createMap();
        },
        methods: {
            ...mapActions({
                getRouteLocations: 'routes/getRouteAndLocations',
                getIsolateRouteLocations: 'routes/getIsolatedRoute',
                setPlanningMapBounds: 'planning/setBounds'
            }),
            createMap() {
                mapboxgl.accessToken = this.accessToken
                // init the map
                this.map = new mapboxgl.Map({
                    container: 'planning',
                    style: this.mapStyle,
                    minzoom: 1.3,
                    center: this.coordinates,
                    zoom: 10,
                })
                this.map.on('load', () => {
                    this.map.resize();

                });

                this.map.addControl(new mapboxgl.NavigationControl())
            },
            setMapBounds() {
                let mapBounds = this.map.getBounds()
                this.setPlanningMapBounds(mapBounds)
            },
            addMarkers() {
                this.clearMarkers()
                this.routeCoordinates.forEach(route => {
                    let marker = new mapboxgl.Marker({ color: route.color })
                        .setLngLat(route.coordinates)
                        .addTo(this.map)

                    this.currentMarkers.push(marker);
                })
            },
            clearMarkers() {
                this.currentMarkers.forEach(marker => {
                    marker.remove()
                    marker = []
                })
            }
        },
        watch: {
            routeLocations(newValue) {
                if (newValue) {
                    this.addMarkers()
                } else {
                    this.clearMarkers()
                }
            }
        },
        computed: {
            ...mapGetters({
                routeLocations: 'planning/previewRoutes'
            }),
            routeCoordinates () {
                const jobTasks = [];
                this.routeLocations.forEach(route => {
                    route.jobTasks.map(task => {
                        jobTasks.push({
                            coordinates: [task.longitude, task.latitude],
                            color: route.color
                        })
                    })
                })
                return jobTasks
            },
        }
    }
</script>
<style>
    .map-container-height{
        height: 100%;
    }
    .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
        margin: 14px 12px 0 0 !important;
    }
    .mapboxgl-canvas {
        height: 100% !important;
    }
    .mapboxgl-marker:hover {
        cursor: pointer;
    }
</style>
